import { NavCountBadge } from '@app/components/layout/sidebar/components/nav-count-badge';
import { useGetSoldFoodAndDrinkList } from '@shared/api/hooks/sold-goods/food-and-drink';
import { Tab } from '@shared/components/page-tabs';
import { generatePath } from 'react-router-dom';
import { soldGoodsRoutes } from '../sold-goods-routes';
import { useSoldFoodAndDrinkItem } from './sold-food-and-drink-item-context';

export function useSoldFoodAndDrinkTabs(): Tab[] {
  const { data } = useGetSoldFoodAndDrinkList();
  const reviewCount = data?.numberOfItemsToReview as number;
  return [
    {
      title: 'Items',
      href: soldGoodsRoutes.SOLD_FOOD_AND_DRINK,
    },
    {
      title: 'Data coverage',
      href: soldGoodsRoutes.SOLD_FOOD_AND_DRINK_DATA_COVERAGE,
    },
    {
      title: 'Review',
      href: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK_REVIEW),
      icon: reviewCount > 0 ? <NavCountBadge count={reviewCount} /> : undefined,
    },
  ];
}

export function useSoldFoodAndDrinkItemsTabs(): Tab[] {
  const { item, referrer } = useSoldFoodAndDrinkItem();
  const company_reports = referrer?.startsWith('/company-reports/')
    ? [referrer.split('/')[2]]
    : undefined;

  return [
    {
      title: 'Item',
      href: generatePath(soldGoodsRoutes.SOLD_FOOD_AND_DRINK_ITEM, {
        item_uuid: item?.uuid || ':item_uuid',
      }),
    },
    {
      title: 'Sales',
      href: generatePath(
        soldGoodsRoutes.SOLD_FOOD_AND_DRINK_ITEM_SALES +
          ((company_reports &&
            `?companyReport=${company_reports?.join(',')}`) ||
            ''),
        {
          item_uuid: item?.uuid || ':item_uuid',
        }
      ),
    },
  ];
}
